// serverTimeUtils.js
export const getServerTime = ({ socketEmit, getStorageData, IISMethods }) => {
    socketEmit('servertime');
    return new Promise((resolve) => {
      IISMethods.setSocketConnection().once('servertime', (data) => {
        let currentDT = IISMethods.GetDTfromISO(data);
        let sysdate = getStorageData('propertydata')?.systemdate.split('T')[0];
        let date = sysdate.split('-');
        // currentDT.setDate(date[2]);
        // currentDT.setMonth(date[1] - 1);
        // currentDT.setYear(date[0]);
        currentDT.setFullYear(date[0]);
        currentDT.setMonth(date[1] - 1);
        currentDT.setDate(date[2]);
        
        resolve(currentDT);
      });
    });
  };
  